import axios from 'axios'
import {EvoMenuTO} from 'generated/JavaTO'

export function fetchMenuAPI() {
	return axios.get<EvoMenuTO[]>("../json/home/menu")
}